import { Exclude, Expose } from 'class-transformer';
import { BaseModel } from '../models';
import { LEAD_STATUS_TYPE, SOURCE_TYPE } from '../types';

@Exclude()
export class CreateCaseCompanyDto extends BaseModel {
  @Expose()
  leadId!: number;

  @Expose()
  source!: SOURCE_TYPE;

  @Expose()
  revenue!: number;

  @Expose()
  uen!: string;

  @Expose()
  status!: LEAD_STATUS_TYPE;

  @Expose()
  companyName!: string;

  @Expose()
  contactName!: string;

  @Expose()
  contactPhoneAreaCode!: string;

  @Expose()
  contactPhoneNumber!: string;

  @Expose()
  contactEmail!: string;

  @Expose()
  remark!: string;

  @Expose()
  hashtag!: string;

  @Expose()
  sourceOther!: string;

  @Expose()
  esgServiceVsGood!: number;

  @Expose()
  productId!: number;
}
